/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidacyListDataSchema = z.object({
	organisation: z.object({ id: z.string(), name: z.string() }),
	candidacies: z.array(
		z.object({
			id: z.string(),
			campaignTitle: z.string(),
			logoUrl: z.string().nullable(),
			submittedAt: z.iso.datetime(),
			cvUploadedAt: z.iso.datetime().nullable(),
		}),
	),
})

export type CandidacyListDataSchema = z.infer<typeof candidacyListDataSchema>
